import { Card, CardBody, Col, Row } from "reactstrap";
import WizardPanel from "../WizardPanel";
import { PanelField } from "../panelFields";

// Delivery stages in flow order, keyed by their `step` value.
const DELIVERY_STAGES = [
  { step: "preparation", label: "Preparing", icon: "fas fa-box" },
  { step: "logistics", label: "Delivery in progress", icon: "fas fa-truck" },
  { step: "delivered", label: "Delivered", icon: "fas fa-check-circle" },
];

// At or past delivery completion, every delivery stage is shown as done.
const DELIVERED_OR_LATER = ["delivered", "waiting_for_veesion", "completed"];

const isOpenableUrl = (value) => /^https?:\/\//i.test((value ?? "").trim());

function DeliveryStatus({ step }) {
  const activeIndex = DELIVERY_STAGES.findIndex((s) => s.step === step);
  const allDone = DELIVERED_OR_LATER.includes(step);

  return (
    <Row className="mt-2">
      {DELIVERY_STAGES.map((stage, i) => {
        const done = allDone || (activeIndex >= 0 && i < activeIndex);
        const active = !allDone && i === activeIndex;
        const color = done ? "success" : active ? "primary" : "secondary";
        const dim = !done && !active;

        return (
          <Col md={4} key={stage.step}>
            <Card className={`h-100 border-${color}`} style={{ opacity: dim ? 0.55 : 1 }}>
              <CardBody className="text-center p-3">
                <i className={`${done ? "fas fa-check-circle" : stage.icon} fa-lg text-${color}`} />
                <div className={`mt-2 font-weight-bold text-${color}`}>{stage.label}</div>
                <small className="text-muted d-block mt-1">
                  {active ? "Current" : done ? "Done" : "Auto — from CRM"}
                </small>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}

/**
 * @param {import("../WizardCard").StepPanelProps} props
 *
 * Editable tracking link plus a read-only delivery-status stepper.
 */
export default function ShippingStatusPanel({ installation, setField, status, bottomNav }) {
  return (
    <WizardPanel
      title="Shipping Status"
      subtitle="Tracking information for the assigned asset"
      status={status}
      bottomNav={bottomNav}
    >
      <Card>
        <CardBody>
          <Row>
            <Col md={6}>
              <PanelField
                label="Tracking link"
                placeholder="https://…"
                value={installation?.tracking_link}
                onChange={(v) => setField("tracking_link", v)}
              />
              {isOpenableUrl(installation?.tracking_link) && (
                <a href={installation.tracking_link} target="_blank" rel="noopener noreferrer" className="small">
                  <i className="fas fa-external-link-alt mr-1" />
                  Open tracking link
                </a>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>

      <label className="text-muted small mb-1">Delivery status</label>
      <DeliveryStatus step={installation?.step} />
    </WizardPanel>
  );
}
